// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;

function getAvailWidth(param) {
  return window.screen.availWidth;
}

var backupClipboard = {
  contents: ""
};

function copyToClipboard(text) {
  backupClipboard.contents = text;
  return navigator.clipboard.writeText(text);
}

function readFromClipboard(param) {
  var match = navigator.clipboard.readText;
  if (match == null) {
    return Expln_utils_promise.promise(function (resolve) {
                Curry._1(resolve, backupClipboard.contents);
              });
  } else {
    return navigator.clipboard.readText();
  }
}

function rndProgress(text, pct, onTerminate, param) {
  return React.createElement(Paper, {
              style: {
                padding: Belt_Option.getWithDefault(Belt_Option.map(onTerminate, (function (param) {
                            return "5px";
                          })), "10px")
              },
              children: Caml_option.some(React.createElement(Expln_React_Row.make, {
                        alignItems: "center",
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement("span", {
                            style: {
                              paddingLeft: "10px"
                            }
                          }, pct !== undefined ? "" + text + ": " + String(Math.round(pct * 100) | 0) + "%" : text), onTerminate !== undefined ? React.createElement(IconButton, {
                              onClick: (function (param) {
                                  Curry._1(onTerminate, undefined);
                                }),
                              children: Caml_option.some(React.createElement(CancelOutlined, {}))
                            }) : null))
            });
}

function openInfoDialog(modalRef, text, onOk, title, param) {
  Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
              return null;
            })), (function (modalId) {
          Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                  var onOk$1 = function (param) {
                    Expln_React_Modal.closeModal(modalRef, modalId);
                    Belt_Option.forEach(onOk, (function (clbk) {
                            Curry._1(clbk, undefined);
                          }));
                  };
                  var tmp = {
                    fontWeight: "bold"
                  };
                  var tmp$1 = Belt_Option.isNone(title) ? "none" : undefined;
                  if (tmp$1 !== undefined) {
                    tmp.display = tmp$1;
                  }
                  return React.createElement(Paper, {
                              style: {
                                padding: "10px"
                              },
                              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                        spacing: 1,
                                        children: Caml_option.some(null)
                                      }, React.createElement("span", {
                                            style: tmp
                                          }, Belt_Option.getWithDefault(title, "")), React.createElement("span", undefined, text), React.createElement(Button, {
                                            onClick: (function (param) {
                                                Curry._1(onOk$1, undefined);
                                              }),
                                            variant: "contained",
                                            children: "Ok"
                                          })))
                            });
                }));
        }));
}

function rndSmallTextBtn(onClick, text) {
  return React.createElement("span", {
              className: "grey-bkg-on-hover",
              style: {
                color: "grey",
                cursor: "pointer",
                fontSize: "0.7em",
                padding: "2px",
                borderRadius: "3px"
              },
              onClick: (function (param) {
                  Curry._1(onClick, undefined);
                })
            }, text);
}

function rndColorSelect(availableColors, selectedColor, onNewColorSelected, label, param) {
  return React.createElement(FormControl, {
              size: "small",
              children: Caml_option.some(null)
            }, label !== undefined ? React.createElement(InputLabel, {
                    id: "label-for-color-select",
                    children: label
                  }) : null, React.createElement(Select, {
                  labelId: "label-for-color-select",
                  label: label,
                  value: selectedColor,
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(onNewColorSelected, param);
                    }),
                  children: Caml_option.some(availableColors.map(function (color) {
                            return JsxPPXReactSupport.createElementWithKey(color, MenuItem, {
                                        value: color,
                                        children: Caml_option.some(React.createElement("div", {
                                                  style: {
                                                    backgroundColor: color,
                                                    height: "20px",
                                                    width: "50px"
                                                  }
                                                }))
                                      });
                          }))
                }));
}

function getFrmLabelBkgColor(frame, settings) {
  if (frame.isDisc) {
    return settings.discColor;
  } else if (frame.isDepr) {
    return settings.deprColor;
  } else if (frame.isTranDepr) {
    return settings.tranDeprColor;
  } else {
    return ;
  }
}

function clickClbkMake(btnOpt, altOpt, shiftOpt, ctrlOpt, act, param) {
  var btn = btnOpt !== undefined ? btnOpt : /* Left */0;
  var alt = altOpt !== undefined ? altOpt : false;
  var shift = shiftOpt !== undefined ? shiftOpt : false;
  var ctrl = ctrlOpt !== undefined ? ctrlOpt : false;
  return {
          btn: btn,
          alt: alt,
          shift: shift,
          ctrl: ctrl,
          act: act
        };
}

function clickHnd(btnOpt, altOpt, shiftOpt, ctrlOpt, act, param, evt) {
  var btn = btnOpt !== undefined ? btnOpt : /* Left */0;
  var alt = altOpt !== undefined ? altOpt : false;
  var shift = shiftOpt !== undefined ? shiftOpt : false;
  var ctrl = ctrlOpt !== undefined ? ctrlOpt : false;
  if (evt.button === btn && evt.altKey === alt && evt.ctrlKey === ctrl && evt.shiftKey === shift) {
    return Curry._1(act, undefined);
  }
  
}

function runClickCallback(evt, clbk) {
  if (evt.button === clbk.btn && evt.altKey === clbk.alt && evt.ctrlKey === clbk.ctrl && evt.shiftKey === clbk.shift) {
    return Curry._1(clbk.act, undefined);
  }
  
}

function clickHnd2(clbk1, clbk2, evt) {
  runClickCallback(evt, clbk1);
  runClickCallback(evt, clbk2);
}

function kbrdClbkMake(key, altOpt, shiftOpt, ctrlOpt, act, param) {
  var alt = altOpt !== undefined ? altOpt : false;
  var shift = shiftOpt !== undefined ? shiftOpt : false;
  var ctrl = ctrlOpt !== undefined ? ctrlOpt : false;
  return {
          key: key.toLowerCase(),
          alt: alt,
          shift: shift,
          ctrl: ctrl,
          act: act
        };
}

function kbrdHnd(key, altOpt, shiftOpt, ctrlOpt, act, param) {
  var alt = altOpt !== undefined ? altOpt : false;
  var shift = shiftOpt !== undefined ? shiftOpt : false;
  var ctrl = ctrlOpt !== undefined ? ctrlOpt : false;
  var key$1 = key.toLowerCase();
  return function (evt) {
    if (evt.key.toLowerCase() === key$1 && evt.altKey === alt && evt.ctrlKey === ctrl && evt.shiftKey === shift) {
      Curry._1(act, undefined);
      evt.stopPropagation();
      evt.preventDefault();
      return ;
    }
    
  };
}

function runKbrdCallback(evt, clbk) {
  if (evt.key.toLowerCase() === clbk.key && evt.altKey === clbk.alt && evt.ctrlKey === clbk.ctrl && evt.shiftKey === clbk.shift) {
    Curry._1(clbk.act, undefined);
    evt.stopPropagation();
    evt.preventDefault();
    return ;
  }
  
}

function kbrdHnd2(clbk1, clbk2, evt) {
  runKbrdCallback(evt, clbk1);
  runKbrdCallback(evt, clbk2);
}

function kbrdHnd3(clbk1, clbk2, clbk3, evt) {
  runKbrdCallback(evt, clbk1);
  runKbrdCallback(evt, clbk2);
  runKbrdCallback(evt, clbk3);
}

var keyEnter = "Enter";

var keyEsc = "Escape";

exports.rndProgress = rndProgress;
exports.openInfoDialog = openInfoDialog;
exports.rndSmallTextBtn = rndSmallTextBtn;
exports.rndColorSelect = rndColorSelect;
exports.getFrmLabelBkgColor = getFrmLabelBkgColor;
exports.copyToClipboard = copyToClipboard;
exports.readFromClipboard = readFromClipboard;
exports.getAvailWidth = getAvailWidth;
exports.clickClbkMake = clickClbkMake;
exports.clickHnd = clickHnd;
exports.clickHnd2 = clickHnd2;
exports.keyEnter = keyEnter;
exports.keyEsc = keyEsc;
exports.kbrdClbkMake = kbrdClbkMake;
exports.kbrdHnd = kbrdHnd;
exports.kbrdHnd2 = kbrdHnd2;
exports.kbrdHnd3 = kbrdHnd3;
/* react Not a pure module */
